import { Link } from "react-router-dom";
import type { SiteLinkProps } from "@quintara/site-kit";

// Adapter that lets @quintara/site-kit components navigate via react-router's
// <Link> (SPA navigation) on the public website. Provided once in Layout so
// every page's shared sections use it.
export function RouterLink({ to, className, style, children }: SiteLinkProps) {
  return (
    <Link to={to} className={className} style={style}>
      {children}
    </Link>
  );
}
